import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-dashed-ring',
  templateUrl: './dashed-ring.component.html',
  styleUrl: './dashed-ring.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashedRingComponent {
  strokeWidth = input(5);
  colors = input(Array(7).fill('#fff'));
}
